'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firebaseSelector = exports.authSelector = exports.routingSelector = undefined;

var _reselect = require('reselect');

var _lodash = require('lodash');

var routingSelector = exports.routingSelector = function routingSelector(state) {
  return state.router.location;
};

var authSelector = exports.authSelector = function authSelector(state) {
  return state.auth;
};
/**
 * We need to use isEqual for equalityCheck, otherwise firebase.listeners compared
 * by === breaks memoization
 */


var firebaseSelector = exports.firebaseSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _lodash.isEqual)(function (state) {
  return state.firebase;
}, function (firebase) {
  return firebase;
});